export default __webpack_public_path__ + "static/media/logo.bc282d39.webp";